import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import "./DepartmentList.css"; // Import the specific CSS
import axios from "axios";

const DepartmentList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [show, setShow] = useState(false);
  const [departmentName, setDepartmentName] = useState("");
  const [search, setSearch] = useState("");

  const [departments, setDepartments] = useState([]);

  const [departId, setDepartId] = useState(null);

  useEffect(() => {
    axios.post(`${API_BASE_URL}department_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setDepartments(response.data.body);
          // setFilteredOrders(response.data.body);
          // console.log(response.data.body[0]);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setDepartments([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setDepartments([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const handleShow = () => {
    setDepartmentName("");
    setDepartId(null);
    setShow(true);
  };

  const handleClose = () => {
    setDepartmentName("");
    setDepartId(null);
    setShow(false);
  };

  const handleEdit = (dept) => {
    setDepartmentName(dept.depart_name);
    setDepartId(dept.depart_id);
    setShow(true);
  };

  const handleSave = () => {
    if (!departmentName.trim()) return;

    if (departId) {
      console.log("department id is ", departId);
      axios.post(`${API_BASE_URL}department_detail_edit.php`,
        {
          depart_id: departId,
          depart_name: departmentName
        }
      )
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    } else {
      console.log("departmentName ", departmentName);

      axios.post(`${API_BASE_URL}department_add.php`, { depart_name: departmentName })
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    }

    handleClose();
  };

  // const handleRemoveDepartment = (id) => {
  //   setDepartments(departments.filter((dept) => dept.id !== id));
  // };
  const handleRemoveDepartment = (depart_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}department_delete.php`, { depart_id: depart_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  const filteredDepartments = departments.filter((d) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      String(d.depart_id).toLowerCase().includes(q) ||
      (d.depart_name && d.depart_name.toLowerCase().includes(q))
    );
  });

  return (
    <>
      <Container fluid className="my-4 outer-container">
        <h2 className="text-center">Department Management</h2>
        {filteredDepartments.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )}
        <Row className="mb-3">
          <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
            <Form.Control
              // className="department-search-input"
              placeholder="Search Department"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>

          <Col xs={0} md={3} lg={4} className="d-none d-md-block"></Col>

          <Col xs={12} md={3} lg={4} className="d-flex justify-content-md-end">
            <div className="w-100 w-md-auto d-flex justify-content-md-end mt-3 mt-md-0">
              <Button className="btn-top" onClick={handleShow}>
                <FaPlus className="me-2" /> Add Department
              </Button>
            </div>
          </Col>
        </Row>

        <Table responsive className="table-striped department-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredDepartments.map((dept, i) => (
              <tr key={dept.id}>
                <td>{i + 1}</td>
                <td>{dept.depart_name}</td>
                <td>
                  <div className="">
                    {dept.depart_name != "Non Teaching Staff" && (
                      <>
                    <FaEdit
                      className="edit-icon me-3"
                      onClick={() => handleEdit(dept)}
                      title="Edit"
                    />
                    <FaTrash
                      className="delete-icon"
                      // onClick={() => handleRemoveDepartment(dept.depart_id)}
                      onClick={() => {
                          if (window.confirm("Are you sure you want to delete this?")) {
                            handleRemoveDepartment(dept.depart_id);
                          }
                        }}
                      title="Delete"
                    />
                    </>
                    )}
                  </div>
                </td>
              </tr>
            ))}

            {/* {filteredDepartments.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center">
                  No departments found
                </td>
              </tr>
            )} */}
          </tbody>
        </Table>
      </Container>

      <Modal show={show} onHide={handleClose} centered className="department-modal">
        <Modal.Header closeButton>
          <Modal.Title>{departId ? "Edit Department" : "Add Department"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Department Name</Form.Label>
              <Form.Control
                type="text"
                value={departmentName}
                onChange={(e) => setDepartmentName(e.target.value)}
                placeholder="Enter department name"
              />
            </Form.Group>
            <Button className="btn-submit btn" onClick={handleSave}>
              {departId ? "Update" : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DepartmentList;